import React, { useState, useEffect, useCallback } from 'react';
import { fleetService } from '../services/fleetService';
import { toast } from 'react-toastify';
import BusMascot from '../components/BusMascot';

// Icons
const MIcons = {
  wrench: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>,
  calendar: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>,
  clipboard: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="8" y="2" width="8" height="4" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><path d="M12 11h4M12 16h4M8 11h.01M8 16h.01"/></svg>,
  alert: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>,
  check: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>,
  plus: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>,
  edit: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>,
  trash: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>,
  dollar: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>,
  clock: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>,
  bus: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M8 6v6M15 6v6M2 12h19.6M18 18h3s.5-1.7.8-2.8c.1-.4.2-.8.2-1.2 0-.4-.1-.8-.2-1.2l-1.4-5C20.1 6.8 19.1 6 18 6H6c-1.1 0-2.1.8-2.4 1.8l-1.4 5c-.1.4-.2.8-.2 1.2 0 .4.1.8.2 1.2.3 1.1.8 2.8.8 2.8h3"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg>,
  refresh: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>,
};

const formatDate = (dateStr) => {
  if (!dateStr) return '—';
  return new Date(dateStr).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

const formatCurrency = (val) => {
  if (!val && val !== 0) return '—';
  return `$${Number(val).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

// ===========================
// MAIN MAINTENANCE TAB
// ===========================
const MaintenanceTab = ({ vehicles = [] }) => {
  const [subTab, setSubTab] = useState('dashboard');
  const [dashboard, setDashboard] = useState(null);
  const [schedules, setSchedules] = useState([]);
  const [workOrders, setWorkOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  // Modals
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [showWorkOrderModal, setShowWorkOrderModal] = useState(false);
  const [showCompleteWOModal, setShowCompleteWOModal] = useState(false);
  const [showCompleteScheduleModal, setShowCompleteScheduleModal] = useState(false);
  const [editingSchedule, setEditingSchedule] = useState(null);
  const [editingWorkOrder, setEditingWorkOrder] = useState(null);
  const [selectedWorkOrder, setSelectedWorkOrder] = useState(null);
  const [selectedSchedule, setSelectedSchedule] = useState(null);

  // Filters
  const [woFilter, setWoFilter] = useState({ status: '', priority: '' });
  const [scheduleSearch, setScheduleSearch] = useState('');

  const fetchDashboard = useCallback(async () => {
    try {
      const data = await fleetService.getMaintenanceDashboard();
      setDashboard(data);
    } catch (err) {
      console.error('Failed to load maintenance dashboard', err);
    }
  }, []);

  const fetchSchedules = useCallback(async () => {
    try {
      const data = await fleetService.getMaintenanceSchedules();
      setSchedules(data.schedules || data || []);
    } catch (err) {
      console.error('Failed to load schedules', err);
    }
  }, []);

  const fetchWorkOrders = useCallback(async () => {
    try {
      const data = await fleetService.getWorkOrders(woFilter);
      setWorkOrders(data.work_orders || data || []);
    } catch (err) {
      console.error('Failed to load work orders', err);
    }
  }, [woFilter]);

  useEffect(() => {
    const loadAll = async () => {
      setLoading(true);
      await Promise.all([fetchDashboard(), fetchSchedules(), fetchWorkOrders()]);
      setLoading(false);
    };
    loadAll();
  }, []);

  useEffect(() => {
    fetchWorkOrders();
  }, [woFilter]);

  const refreshAll = async () => {
    await Promise.all([fetchDashboard(), fetchSchedules(), fetchWorkOrders()]);
    toast.success('Data refreshed');
  };

  const handleDeleteSchedule = async (id) => {
    if (!window.confirm('Delete this maintenance schedule?')) return;
    try {
      await fleetService.deleteMaintenanceSchedule(id);
      toast.success('Schedule deleted');
      fetchSchedules();
      fetchDashboard();
    } catch (err) {
      toast.error('Failed to delete schedule');
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <BusMascot size={60} animated />
        <p>Loading maintenance data...</p>
      </div>
    );
  }

  return (
    <div className="maintenance-tab">
      {/* Sub-Tab Navigation */}
      <div className="maint-sub-tabs">
        <button className={`maint-sub-tab ${subTab === 'dashboard' ? 'active' : ''}`} onClick={() => setSubTab('dashboard')}>
          {MIcons.clipboard} Dashboard
        </button>
        <button className={`maint-sub-tab ${subTab === 'schedules' ? 'active' : ''}`} onClick={() => setSubTab('schedules')}>
          {MIcons.calendar} Schedules
        </button>
        <button className={`maint-sub-tab ${subTab === 'workorders' ? 'active' : ''}`} onClick={() => setSubTab('workorders')}>
          {MIcons.wrench} Work Orders
        </button>
        <div style={{ marginLeft: 'auto' }}>
          <button className="btn-secondary" onClick={refreshAll} style={{ display: 'flex', alignItems: 'center', gap: '0.375rem', padding: '0.5rem 1rem' }}>
            {MIcons.refresh} Refresh
          </button>
        </div>
      </div>

      {/* DASHBOARD SUB-TAB */}
      {subTab === 'dashboard' && (
        <DashboardView
          dashboard={dashboard}
          onCreateSchedule={() => { setEditingSchedule(null); setShowScheduleModal(true); }}
          onCreateWorkOrder={() => { setEditingWorkOrder(null); setShowWorkOrderModal(true); }}
          onViewSchedules={() => setSubTab('schedules')}
          onViewWorkOrders={() => setSubTab('workorders')}
        />
      )}

      {/* SCHEDULES SUB-TAB */}
      {subTab === 'schedules' && (
        <SchedulesView
          schedules={schedules}
          search={scheduleSearch}
          onSearchChange={setScheduleSearch}
          onAdd={() => { setEditingSchedule(null); setShowScheduleModal(true); }}
          onEdit={(s) => { setEditingSchedule(s); setShowScheduleModal(true); }}
          onDelete={handleDeleteSchedule}
          onComplete={(s) => { setSelectedSchedule(s); setShowCompleteScheduleModal(true); }}
        />
      )}

      {/* WORK ORDERS SUB-TAB */}
      {subTab === 'workorders' && (
        <WorkOrdersView
          workOrders={workOrders}
          filter={woFilter}
          onFilterChange={setWoFilter}
          onAdd={() => { setEditingWorkOrder(null); setShowWorkOrderModal(true); }}
          onEdit={(wo) => { setEditingWorkOrder(wo); setShowWorkOrderModal(true); }}
          onComplete={(wo) => { setSelectedWorkOrder(wo); setShowCompleteWOModal(true); }}
        />
      )}

      {/* SCHEDULE MODAL */}
      {showScheduleModal && (
        <ScheduleModal
          schedule={editingSchedule}
          vehicles={vehicles}
          onClose={() => { setShowScheduleModal(false); setEditingSchedule(null); }}
          onSave={() => { setShowScheduleModal(false); setEditingSchedule(null); fetchSchedules(); fetchDashboard(); }}
        />
      )}

      {/* COMPLETE SCHEDULE MODAL */}
      {showCompleteScheduleModal && selectedSchedule && (
        <CompleteScheduleModal
          schedule={selectedSchedule}
          onClose={() => { setShowCompleteScheduleModal(false); setSelectedSchedule(null); }}
          onSave={() => { setShowCompleteScheduleModal(false); setSelectedSchedule(null); fetchSchedules(); fetchDashboard(); }}
        />
      )}

      {/* WORK ORDER MODAL */}
      {showWorkOrderModal && (
        <WorkOrderModal
          workOrder={editingWorkOrder}
          vehicles={vehicles}
          onClose={() => { setShowWorkOrderModal(false); setEditingWorkOrder(null); }}
          onSave={() => { setShowWorkOrderModal(false); setEditingWorkOrder(null); fetchWorkOrders(); fetchDashboard(); }}
        />
      )}

      {/* COMPLETE WORK ORDER MODAL */}
      {showCompleteWOModal && selectedWorkOrder && (
        <CompleteWorkOrderModal
          workOrder={selectedWorkOrder}
          onClose={() => { setShowCompleteWOModal(false); setSelectedWorkOrder(null); }}
          onSave={() => { setShowCompleteWOModal(false); setSelectedWorkOrder(null); fetchWorkOrders(); fetchDashboard(); fetchSchedules(); }}
        />
      )}
    </div>
  );
};


// ===========================
// DASHBOARD VIEW
// ===========================
const DashboardView = ({ dashboard, onCreateSchedule, onCreateWorkOrder, onViewSchedules, onViewWorkOrders }) => {
  if (!dashboard) {
    return (
      <div className="empty-state">
        <div className="empty-state-icon">{MIcons.wrench}</div>
        <h3>No maintenance data yet</h3>
        <p>Create your first maintenance schedule or work order to get started</p>
      </div>
    );
  }

  const stats = dashboard.stats || dashboard;

  return (
    <div className="maint-dashboard">
      {/* Stats Cards */}
      <div className="maint-stats-grid">
        <div className="maint-stat-card overdue" onClick={onViewSchedules} style={{ boxShadow: '0 0 25px rgba(212,169,78,0.35), 0 0 50px rgba(212,169,78,0.15), 0 0 80px rgba(212,169,78,0.05)' }}>
          <div className="maint-stat-icon">{MIcons.alert}</div>
          <div className="maint-stat-value">{stats.overdue_schedules || 0}</div>
          <div className="maint-stat-label">Overdue</div>
        </div>
        <div className="maint-stat-card due-soon" onClick={onViewSchedules} style={{ boxShadow: '0 0 25px rgba(212,169,78,0.35), 0 0 50px rgba(212,169,78,0.15), 0 0 80px rgba(212,169,78,0.05)' }}>
          <div className="maint-stat-icon">{MIcons.calendar}</div>
          <div className="maint-stat-value">{stats.due_soon || 0}</div>
          <div className="maint-stat-label">Due Soon</div>
        </div>
        <div className="maint-stat-card open-wo" onClick={onViewWorkOrders} style={{ boxShadow: '0 0 25px rgba(212,169,78,0.35), 0 0 50px rgba(212,169,78,0.15), 0 0 80px rgba(212,169,78,0.05)' }}>
          <div className="maint-stat-icon">{MIcons.clipboard}</div>
          <div className="maint-stat-value">{stats.open_work_orders || 0}</div>
          <div className="maint-stat-label">Open Work Orders</div>
        </div>
        <div className="maint-stat-card cost" style={{ boxShadow: '0 0 25px rgba(212,169,78,0.35), 0 0 50px rgba(212,169,78,0.15), 0 0 80px rgba(212,169,78,0.05)' }}>
          <div className="maint-stat-icon">{MIcons.dollar}</div>
          <div className="maint-stat-value">{formatCurrency(stats.total_cost_30_days || 0)}</div>
          <div className="maint-stat-label">30-Day Costs</div>
        </div>
      </div>

      {/* Quick Actions */}
      <div className="maint-quick-actions">
        <h3>Quick Actions</h3>
        <div className="maint-action-buttons">
          <button className="btn-primary" onClick={onCreateSchedule}>
            {MIcons.plus} New Schedule
          </button>
          <button className="btn-primary" onClick={onCreateWorkOrder}>
            {MIcons.plus} New Work Order
          </button>
        </div>
      </div>

      {/* Recent Completions */}
      {stats.recent_completions && stats.recent_completions.length > 0 && (
        <div className="maint-recent">
          <h3>Recent Completions</h3>
          <div className="maint-recent-list">
            {stats.recent_completions.map((item, idx) => (
              <div key={idx} className="maint-recent-item">
                <div className="maint-recent-icon">{MIcons.check}</div>
                <div className="maint-recent-content">
                  <div className="maint-recent-title">{item.title || item.maintenance_type}</div>
                  <div className="maint-recent-meta">
                    {item.bus_number && <span>{MIcons.bus} {item.bus_number}</span>}
                    <span>{MIcons.clock} {formatDate(item.date_completed || item.maintenance_date)}</span>
                    {item.total_cost > 0 && <span>{formatCurrency(item.total_cost)}</span>}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};


// ===========================
// SCHEDULES VIEW
// ===========================
const SchedulesView = ({ schedules, search, onSearchChange, onAdd, onEdit, onDelete, onComplete }) => {
  const filtered = schedules.filter(s => {
    if (!search) return true;
    const q = search.toLowerCase();
    return (
      s.schedule_name?.toLowerCase().includes(q) ||
      s.maintenance_type?.toLowerCase().includes(q) ||
      s.bus_number?.toLowerCase().includes(q)
    );
  });

  const getDueStatus = (schedule) => {
    if (!schedule.next_due_date) return null;
    const now = new Date();
    const due = new Date(schedule.next_due_date);
    const diff = Math.ceil((due - now) / (1000 * 60 * 60 * 24));
    if (diff < 0) return { label: `${Math.abs(diff)}d overdue`, className: 'due-overdue' };
    if (diff <= 7) return { label: `${diff}d left`, className: 'due-urgent' };
    if (diff <= 14) return { label: `${diff}d left`, className: 'due-soon' };
    return { label: `${diff}d left`, className: 'due-ok' };
  };

  return (
    <div>
      <div className="fleet-filters">
        <input
          type="text"
          placeholder="Search schedules..."
          className="search-input"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
        />
        <button className="btn-primary" onClick={onAdd} style={{ display: 'flex', alignItems: 'center', gap: '0.375rem' }}>
          {MIcons.plus} New Schedule
        </button>
      </div>

      {filtered.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon">{MIcons.calendar}</div>
          <h3>No maintenance schedules</h3>
          <p>Create a preventive maintenance schedule to stay ahead</p>
        </div>
      ) : (
        <div className="fleet-table-container">
          <table className="fleet-table">
            <thead>
              <tr>
                <th>Schedule Name</th>
                <th>Vehicle</th>
                <th>Type</th>
                <th>Interval</th>
                <th>Next Due</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(schedule => {
                const due = getDueStatus(schedule);
                return (
                  <tr key={schedule.id} className={due?.className === 'due-overdue' ? 'out-of-service' : ''}>
                    <td><span style={{ fontWeight: 600, color: '#FFFFFF' }}>{schedule.schedule_name}</span></td>
                    <td>
                      {schedule.is_fleet_wide ? (
                        <span className="maint-fleet-badge">All Vehicles</span>
                      ) : (
                        <span>{schedule.bus_number || '—'}</span>
                      )}
                    </td>
                    <td><span className="maint-type-badge">{schedule.maintenance_type}</span></td>
                    <td>
                      <div>
                        {schedule.interval_days && <span>{schedule.interval_days} days</span>}
                        {schedule.interval_days && schedule.interval_miles && <span> / </span>}
                        {schedule.interval_miles && <span>{schedule.interval_miles.toLocaleString()} mi</span>}
                      </div>
                    </td>
                    <td>{formatDate(schedule.next_due_date)}</td>
                    <td>
                      {due ? (
                        <span className={`maint-due-badge ${due.className}`}>{due.label}</span>
                      ) : (
                        <span style={{ color: '#6B6B6B' }}>Not set</span>
                      )}
                    </td>
                    <td>
                      <div className="action-buttons">
                        <button className="btn-icon status" title="Mark Complete" onClick={() => onComplete(schedule)}>
                          {MIcons.check}
                        </button>
                        <button className="btn-icon edit" title="Edit" onClick={() => onEdit(schedule)}>
                          {MIcons.edit}
                        </button>
                        <button className="btn-icon dispose" title="Delete" onClick={() => onDelete(schedule.id)}>
                          {MIcons.trash}
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};


// ===========================
// WORK ORDERS VIEW
// ===========================
const WorkOrdersView = ({ workOrders, filter, onFilterChange, onAdd, onEdit, onComplete }) => {
  const getPriorityBadge = (priority) => {
    const config = {
      urgent: { label: 'Urgent', className: 'wo-priority-urgent' },
      high: { label: 'High', className: 'wo-priority-high' },
      normal: { label: 'Normal', className: 'wo-priority-normal' },
      low: { label: 'Low', className: 'wo-priority-low' },
    };
    const c = config[priority] || config.normal;
    return <span className={`wo-priority-badge ${c.className}`}>{c.label}</span>;
  };

  const getStatusBadge = (status) => {
    const config = {
      open: { label: 'Open', className: 'wo-status-open' },
      in_progress: { label: 'In Progress', className: 'wo-status-progress' },
      on_hold: { label: 'On Hold', className: 'wo-status-hold' },
      completed: { label: 'Completed', className: 'wo-status-completed' },
      cancelled: { label: 'Cancelled', className: 'wo-status-cancelled' },
    };
    const c = config[status] || config.open;
    return <span className={`wo-status-badge ${c.className}`}>{c.label}</span>;
  };

  return (
    <div>
      <div className="fleet-filters">
        <select
          className="filter-select"
          value={filter.status}
          onChange={(e) => onFilterChange({ ...filter, status: e.target.value })}
        >
          <option value="">All Statuses</option>
          <option value="open">Open</option>
          <option value="in_progress">In Progress</option>
          <option value="on_hold">On Hold</option>
          <option value="completed">Completed</option>
          <option value="cancelled">Cancelled</option>
        </select>
        <select
          className="filter-select"
          value={filter.priority}
          onChange={(e) => onFilterChange({ ...filter, priority: e.target.value })}
        >
          <option value="">All Priorities</option>
          <option value="urgent">Urgent</option>
          <option value="high">High</option>
          <option value="normal">Normal</option>
          <option value="low">Low</option>
        </select>
        <div style={{ marginLeft: 'auto' }}>
          <button className="btn-primary" onClick={onAdd} style={{ display: 'flex', alignItems: 'center', gap: '0.375rem' }}>
            {MIcons.plus} New Work Order
          </button>
        </div>
      </div>

      {workOrders.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon">{MIcons.clipboard}</div>
          <h3>No work orders</h3>
          <p>Create a work order to track maintenance tasks</p>
        </div>
      ) : (
        <div className="fleet-table-container">
          <table className="fleet-table">
            <thead>
              <tr>
                <th>WO #</th>
                <th>Title</th>
                <th>Vehicle</th>
                <th>Priority</th>
                <th>Status</th>
                <th>Assigned To</th>
                <th>Due Date</th>
                <th>Cost</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {workOrders.map(wo => (
                <tr key={wo.id} className={wo.priority === 'urgent' ? 'out-of-service' : ''}>
                  <td><span style={{ fontWeight: 600, fontFamily: 'monospace' }}>{wo.work_order_number}</span></td>
                  <td><span style={{ fontWeight: 500, color: '#FFFFFF' }}>{wo.title}</span></td>
                  <td>{wo.bus_number || '—'}</td>
                  <td>{getPriorityBadge(wo.priority)}</td>
                  <td>{getStatusBadge(wo.status)}</td>
                  <td>{wo.assigned_to || '—'}</td>
                  <td>{formatDate(wo.due_date)}</td>
                  <td>{wo.total_cost > 0 ? formatCurrency(wo.total_cost) : '—'}</td>
                  <td>
                    <div className="action-buttons">
                      {wo.status !== 'completed' && wo.status !== 'cancelled' && (
                        <button className="btn-icon status" title="Complete" onClick={() => onComplete(wo)}>
                          {MIcons.check}
                        </button>
                      )}
                      <button className="btn-icon edit" title="Edit" onClick={() => onEdit(wo)}>
                        {MIcons.edit}
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};


// ===========================
// SCHEDULE MODAL (Create/Edit)
// ===========================
const ScheduleModal = ({ schedule, vehicles, onClose, onSave }) => {
  const [form, setForm] = useState({
    schedule_name: schedule?.schedule_name || '',
    maintenance_type: schedule?.maintenance_type || 'oil_change',
    description: schedule?.description || '',
    vehicle_id: schedule?.vehicle_id || '',
    is_fleet_wide: schedule?.is_fleet_wide || false,
    interval_days: schedule?.interval_days || '',
    interval_miles: schedule?.interval_miles || '',
    next_due_date: schedule?.next_due_date ? schedule.next_due_date.split('T')[0] : '',
    next_due_mileage: schedule?.next_due_mileage || '',
    priority: schedule?.priority || 'normal',
  });
  const [saving, setSaving] = useState(false);

  const maintenanceTypes = [
    'oil_change', 'tire_rotation', 'brake_inspection', 'brake_replacement',
    'transmission_service', 'coolant_flush', 'air_filter', 'fuel_filter',
    'battery_check', 'belt_inspection', 'suspension_check', 'alignment',
    'DOT_inspection', 'emissions_test', 'general_inspection', 'winterization',
    'de_winterization', 'other'
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.schedule_name) { toast.error('Schedule name is required'); return; }
    if (!form.is_fleet_wide && !form.vehicle_id) { toast.error('Select a vehicle or mark as fleet-wide'); return; }

    try {
      setSaving(true);
      const payload = {
        ...form,
        interval_days: form.interval_days ? parseInt(form.interval_days) : null,
        interval_miles: form.interval_miles ? parseInt(form.interval_miles) : null,
        next_due_mileage: form.next_due_mileage ? parseInt(form.next_due_mileage) : null,
        vehicle_id: form.is_fleet_wide ? null : form.vehicle_id,
      };
      if (schedule?.id) {
        await fleetService.updateMaintenanceSchedule(schedule.id, payload);
        toast.success('Schedule updated');
      } else {
        await fleetService.createMaintenanceSchedule(payload);
        toast.success('Schedule created');
      }
      onSave();
    } catch (err) {
      toast.error(err.message || 'Failed to save schedule');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{schedule ? 'Edit' : 'New'} Maintenance Schedule</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label>Schedule Name *</label>
              <input type="text" value={form.schedule_name} onChange={(e) => setForm({ ...form, schedule_name: e.target.value })} placeholder="e.g., Quarterly Oil Change" required />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Maintenance Type</label>
                <select value={form.maintenance_type} onChange={(e) => setForm({ ...form, maintenance_type: e.target.value })}>
                  {maintenanceTypes.map(t => (
                    <option key={t} value={t}>{t.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Priority</label>
                <select value={form.priority} onChange={(e) => setForm({ ...form, priority: e.target.value })}>
                  <option value="low">Low</option>
                  <option value="normal">Normal</option>
                  <option value="high">High</option>
                  <option value="urgent">Urgent</option>
                </select>
              </div>
            </div>

            <div className="form-group">
              <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <input type="checkbox" checked={form.is_fleet_wide} onChange={(e) => setForm({ ...form, is_fleet_wide: e.target.checked })} />
                Apply to entire fleet
              </label>
            </div>

            {!form.is_fleet_wide && (
              <div className="form-group">
                <label>Vehicle *</label>
                <select value={form.vehicle_id} onChange={(e) => setForm({ ...form, vehicle_id: e.target.value })}>
                  <option value="">Select vehicle...</option>
                  {vehicles.filter(v => v.status !== 'retired').map(v => (
                    <option key={v.id} value={v.id}>{v.bus_number} — {v.make} {v.model} {v.year}</option>
                  ))}
                </select>
              </div>
            )}

            <div className="form-group">
              <label>Description</label>
              <textarea rows={2} value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} placeholder="Optional details about this schedule" />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Interval (Days)</label>
                <input type="number" value={form.interval_days} onChange={(e) => setForm({ ...form, interval_days: e.target.value })} placeholder="e.g., 90" />
              </div>
              <div className="form-group">
                <label>Interval (Miles)</label>
                <input type="number" value={form.interval_miles} onChange={(e) => setForm({ ...form, interval_miles: e.target.value })} placeholder="e.g., 5000" />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Next Due Date</label>
                <input type="date" value={form.next_due_date} onChange={(e) => setForm({ ...form, next_due_date: e.target.value })} />
              </div>
              <div className="form-group">
                <label>Next Due Mileage</label>
                <input type="number" value={form.next_due_mileage} onChange={(e) => setForm({ ...form, next_due_mileage: e.target.value })} placeholder="e.g., 50000" />
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn-secondary" onClick={onClose}>Cancel</button>
            <button type="submit" className="btn-primary" disabled={saving}>
              {saving ? 'Saving...' : schedule ? 'Update Schedule' : 'Create Schedule'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};


// ===========================
// COMPLETE SCHEDULE MODAL
// ===========================
const CompleteScheduleModal = ({ schedule, onClose, onSave }) => {
  const [form, setForm] = useState({
    completed_date: new Date().toISOString().split('T')[0],
    completed_mileage: '',
    notes: '',
  });
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSaving(true);
      await fleetService.completeMaintenanceSchedule(schedule.id, {
        completed_date: form.completed_date,
        completed_mileage: form.completed_mileage ? parseInt(form.completed_mileage) : null,
        notes: form.notes,
      });
      toast.success(`"${schedule.schedule_name}" marked complete — next due date advanced`);
      onSave();
    } catch (err) {
      toast.error(err.message || 'Failed to complete schedule');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Complete Maintenance: {schedule.schedule_name}</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="maint-complete-info">
              <p><strong>Vehicle:</strong> {schedule.is_fleet_wide ? 'Fleet-wide' : schedule.bus_number}</p>
              <p><strong>Type:</strong> {schedule.maintenance_type?.replace(/_/g, ' ')}</p>
              {schedule.next_due_date && <p><strong>Was due:</strong> {formatDate(schedule.next_due_date)}</p>}
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Completed Date</label>
                <input type="date" value={form.completed_date} onChange={(e) => setForm({ ...form, completed_date: e.target.value })} />
              </div>
              <div className="form-group">
                <label>Mileage at Service</label>
                <input type="number" value={form.completed_mileage} onChange={(e) => setForm({ ...form, completed_mileage: e.target.value })} placeholder="Current odometer" />
              </div>
            </div>

            <div className="form-group">
              <label>Notes</label>
              <textarea rows={3} value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} placeholder="Service notes, parts replaced, etc." />
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn-secondary" onClick={onClose}>Cancel</button>
            <button type="submit" className="btn-success" disabled={saving}>
              {saving ? 'Saving...' : 'Mark Complete'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};


// ===========================
// WORK ORDER MODAL (Create/Edit)
// ===========================
const WorkOrderModal = ({ workOrder, vehicles, onClose, onSave }) => {
  const [form, setForm] = useState({
    title: workOrder?.title || '',
    description: workOrder?.description || '',
    vehicle_id: workOrder?.vehicle_id || '',
    order_type: workOrder?.order_type || 'corrective',
    priority: workOrder?.priority || 'normal',
    assigned_to: workOrder?.assigned_to || '',
    vendor: workOrder?.vendor || '',
    due_date: workOrder?.due_date ? workOrder.due_date.split('T')[0] : '',
    date_scheduled: workOrder?.date_scheduled ? workOrder.date_scheduled.split('T')[0] : '',
    estimated_cost: workOrder?.estimated_cost || '',
    status: workOrder?.status || 'open',
  });
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.title) { toast.error('Title is required'); return; }
    if (!form.vehicle_id) { toast.error('Select a vehicle'); return; }

    try {
      setSaving(true);
      const payload = {
        ...form,
        estimated_cost: form.estimated_cost ? parseFloat(form.estimated_cost) : null,
      };
      if (workOrder?.id) {
        await fleetService.updateWorkOrder(workOrder.id, payload);
        toast.success('Work order updated');
      } else {
        await fleetService.createWorkOrder(payload);
        toast.success('Work order created');
      }
      onSave();
    } catch (err) {
      toast.error(err.message || 'Failed to save work order');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{workOrder ? `Edit ${workOrder.work_order_number}` : 'New Work Order'}</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label>Title *</label>
              <input type="text" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} placeholder="e.g., Replace brake pads — Bus GV0023" required />
            </div>

            <div className="form-group">
              <label>Vehicle *</label>
              <select value={form.vehicle_id} onChange={(e) => setForm({ ...form, vehicle_id: e.target.value })}>
                <option value="">Select vehicle...</option>
                {vehicles.filter(v => v.status !== 'retired').map(v => (
                  <option key={v.id} value={v.id}>{v.bus_number} — {v.make} {v.model} {v.year}</option>
                ))}
              </select>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Order Type</label>
                <select value={form.order_type} onChange={(e) => setForm({ ...form, order_type: e.target.value })}>
                  <option value="preventive">Preventive</option>
                  <option value="corrective">Corrective</option>
                  <option value="emergency">Emergency</option>
                  <option value="inspection">Inspection</option>
                </select>
              </div>
              <div className="form-group">
                <label>Priority</label>
                <select value={form.priority} onChange={(e) => setForm({ ...form, priority: e.target.value })}>
                  <option value="low">Low</option>
                  <option value="normal">Normal</option>
                  <option value="high">High</option>
                  <option value="urgent">Urgent</option>
                </select>
              </div>
            </div>

            {workOrder && (
              <div className="form-group">
                <label>Status</label>
                <select value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })}>
                  <option value="open">Open</option>
                  <option value="in_progress">In Progress</option>
                  <option value="on_hold">On Hold</option>
                  <option value="cancelled">Cancelled</option>
                </select>
              </div>
            )}

            <div className="form-row">
              <div className="form-group">
                <label>Assigned To</label>
                <input type="text" value={form.assigned_to} onChange={(e) => setForm({ ...form, assigned_to: e.target.value })} placeholder="Mechanic or shop name" />
              </div>
              <div className="form-group">
                <label>Vendor / Shop</label>
                <input type="text" value={form.vendor} onChange={(e) => setForm({ ...form, vendor: e.target.value })} placeholder="External vendor" />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Due Date</label>
                <input type="date" value={form.due_date} onChange={(e) => setForm({ ...form, due_date: e.target.value })} />
              </div>
              <div className="form-group">
                <label>Estimated Cost</label>
                <input type="number" step="0.01" value={form.estimated_cost} onChange={(e) => setForm({ ...form, estimated_cost: e.target.value })} placeholder="$0.00" />
              </div>
            </div>

            <div className="form-group">
              <label>Description</label>
              <textarea rows={3} value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} placeholder="Work to be done, symptoms, etc." />
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn-secondary" onClick={onClose}>Cancel</button>
            <button type="submit" className="btn-primary" disabled={saving}>
              {saving ? 'Saving...' : workOrder ? 'Update Work Order' : 'Create Work Order'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};


// ===========================
// COMPLETE WORK ORDER MODAL
// ===========================
const CompleteWorkOrderModal = ({ workOrder, onClose, onSave }) => {
  const [form, setForm] = useState({
    parts_cost: workOrder.parts_cost || '',
    labor_cost: workOrder.labor_cost || '',
    labor_hours: workOrder.labor_hours || '',
    mileage_at_service: workOrder.mileage_at_service || '',
    parts_used: workOrder.parts_used || '',
    resolution_notes: workOrder.resolution_notes || '',
  });
  const [saving, setSaving] = useState(false);

  const totalCost = (parseFloat(form.parts_cost) || 0) + (parseFloat(form.labor_cost) || 0);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSaving(true);
      await fleetService.updateWorkOrder(workOrder.id, {
        status: 'completed',
        parts_cost: form.parts_cost ? parseFloat(form.parts_cost) : 0,
        labor_cost: form.labor_cost ? parseFloat(form.labor_cost) : 0,
        labor_hours: form.labor_hours ? parseFloat(form.labor_hours) : null,
        mileage_at_service: form.mileage_at_service ? parseInt(form.mileage_at_service) : null,
        parts_used: form.parts_used,
        resolution_notes: form.resolution_notes,
      });
      toast.success(`${workOrder.work_order_number} completed!`);
      onSave();
    } catch (err) {
      toast.error(err.message || 'Failed to complete work order');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Complete {workOrder.work_order_number}</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="maint-complete-info">
              <p><strong>Title:</strong> {workOrder.title}</p>
              <p><strong>Vehicle:</strong> {workOrder.bus_number}</p>
              <p><strong>Type:</strong> {workOrder.order_type}</p>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Parts Cost ($)</label>
                <input type="number" step="0.01" value={form.parts_cost} onChange={(e) => setForm({ ...form, parts_cost: e.target.value })} placeholder="0.00" />
              </div>
              <div className="form-group">
                <label>Labor Cost ($)</label>
                <input type="number" step="0.01" value={form.labor_cost} onChange={(e) => setForm({ ...form, labor_cost: e.target.value })} placeholder="0.00" />
              </div>
            </div>

            <div className="wo-total-cost">
              <span>Total Cost:</span>
              <strong>{formatCurrency(totalCost)}</strong>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Labor Hours</label>
                <input type="number" step="0.5" value={form.labor_hours} onChange={(e) => setForm({ ...form, labor_hours: e.target.value })} placeholder="e.g., 2.5" />
              </div>
              <div className="form-group">
                <label>Mileage at Service</label>
                <input type="number" value={form.mileage_at_service} onChange={(e) => setForm({ ...form, mileage_at_service: e.target.value })} placeholder="Current odometer" />
              </div>
            </div>

            <div className="form-group">
              <label>Parts Used</label>
              <textarea rows={2} value={form.parts_used} onChange={(e) => setForm({ ...form, parts_used: e.target.value })} placeholder="List of parts replaced" />
            </div>

            <div className="form-group">
              <label>Resolution Notes</label>
              <textarea rows={3} value={form.resolution_notes} onChange={(e) => setForm({ ...form, resolution_notes: e.target.value })} placeholder="What was done, findings, recommendations..." />
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn-secondary" onClick={onClose}>Cancel</button>
            <button type="submit" className="btn-success" disabled={saving}>
              {saving ? 'Completing...' : 'Complete Work Order'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MaintenanceTab;
